export default class TutorialTextConfig {
  constructor(textKey, customElements) {
    this.textKey = textKey;
    this.customElements = customElements;
  }
}
